<section class="cmn-innerpage-wrapper">
  <div class="tab-content-wrapper">
    <form [formGroup]="taskForm">
      <div class="employee-form-wrapper">
        <div class="grid-wrapper-2">
          <div class="form-wrapper">
            <label for="">Task Name <span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter Task Name"
                formControlName="taskName"
                maxlength="45"
              />
            </mat-form-field>
            <div
              class="custom-error"
              *ngIf="
            taskForm.get('taskName')?.invalid &&
            taskForm.get('taskName')?.touched
          "
            >
              <span>
                <mat-error
                  *ngIf="taskForm.get('taskName')!.touched &&
                    taskForm.get('taskName')!.hasError('required')"
                  >Task name is required</mat-error
                >
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Task Code <span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter Task Code"
                formControlName="taskCode"
                maxlength="45"
              />
            </mat-form-field>
            <div
              class="custom-error"
              *ngIf="
            taskForm.get('taskCode')?.invalid &&
            taskForm.get('taskCode')?.touched
          "
            >
              <span>
                <mat-error
                  *ngIf="taskForm.get('taskCode')!.touched &&
                    taskForm.get('taskCode')!.hasError('required')"
                  >Task code is required</mat-error
                >
              </span>
            </div>
          </div>
        </div>

        <!-- Variants -->
        <div class="chart-account-form-wrapper" [formGroup]="variantForm">
          <h4>ADD VARIANTS</h4>
          <div class="grid-wrapper-3">
            <div class="form-wrapper">
              <label>Task Variant Name</label>
              <mat-form-field>
                <input
                  matInput
                  placeholder="Enter variant name"
                  formControlName="variantName"
                />
              </mat-form-field>
              <div
                class="custom-error"
                *ngIf="
            variantForm.get('variantName')?.invalid &&
            variantForm.get('variantName')?.touched
          "
              >
                <span>
                  <mat-error
                    *ngIf="variantForm.get('variantName')!.touched &&
                    variantForm.get('variantName')!.hasError('required')"
                    >Variant name is required</mat-error
                  >
                </span>
              </div>
            </div>

            <div class="form-wrapper">
              <label>Price</label>
              <mat-form-field>
                <input
                  matInput
                  placeholder="Enter price"
                  formControlName="price"
                  type="number"
                />
              </mat-form-field>
              <div
                class="custom-error"
                *ngIf="
            variantForm.get('price')?.invalid &&
            variantForm.get('price')?.touched
          "
              >
                <span>
                  <mat-error
                    *ngIf="variantForm.get('price')!.touched &&
                    variantForm.get('price')!.hasError('required')"
                    >Price is required</mat-error
                  >
                </span>
              </div>
            </div>

            <div class="form-wrapper">
              <label>Estimated Time</label>
              <mat-form-field>
                <input
                  matInput
                  placeholder="Enter estimated time"
                  formControlName="estimatedTime"
                />
              </mat-form-field>
              <div
                class="custom-error"
                *ngIf="
            variantForm.get('estimatedTime')?.invalid &&
            variantForm.get('estimatedTime')?.touched
          "
              >
                <span>
                  <mat-error
                    *ngIf="variantForm.get('estimatedTime')!.touched &&
                    variantForm.get('estimatedTime')!.hasError('required')"
                    >Estimated time is required</mat-error
                  >
                </span>
              </div>
            </div>
          </div>

          <button class="cmn-next-btn" type="button" (click)="saveVariant()">
            <img
              src="assets/images/icons/icon-add-color.svg"
              alt="Save Variant"
            />
            {{ editVariantIndex !== null ? 'Update Variant' : 'Add Variant' }}
          </button>
        </div>

        <!-- Table displaying variants in the FormArray -->
        <div
          class="item-service-adding-table-wrapper"
          *ngIf="variantsFormArray.length > 0"
        >
          <table>
            <thead>
              <tr>
                <th>Variant Name</th>
                <th>Price</th>
                <th>Estimated Time</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody formArrayName="variants">
              <tr
                *ngFor="let variant of variantsFormArray?.controls; let i = index"
                [formGroupName]="i"
              >
                <td>{{ variant?.get('variantName')?.value }}</td>
                <td>{{ variant?.get('price')?.value }}</td>
                <td>{{ variant?.get('estimatedTime')?.value }}</td>
                <td>
                  <div class="action-wrapper">
                    <img
                      src="../../../assets/images/icons/icon-edit.svg"
                      alt="Edit"
                      (click)="onEditVariant(i)"
                    />
                    <img
                      src="../../../assets/images/icons/icon-delete.svg"
                      alt="Delete"
                      (click)="removeVariant(i)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Checklist -->
        <div class="chart-account-form-wrapper">
          <h4>ADD CHECKLISTS</h4>
          <div class="form-wrapper">
            <label for="">Checklist Name</label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter checklists"
                formControlName="itemName"
              />
            </mat-form-field>
          </div>
          <button
            class="cmn-next-btn"
            type="button"
            (click)="addChecklist(taskForm.get('itemName')?.value)"
          >
            <img src="assets/images/icons/icon-add-color.svg" alt="Add Stock" />
            {{ editChecklistIndex !== null ? 'Update Checklist' : 'Add
            Checklist' }}
          </button>
        </div>

        <div
          class="item-service-adding-table-wrapper"
          *ngIf="(itemArray?.length ?? 0) > 0"
        >
          <table>
            <thead>
              <tr>
                <th>Checklist Name</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of itemArray; let i = index">
                <td>{{ item?.itemName }}</td>
                <td>
                  <div class="action-wrapper">
                    <img
                      src="../../../assets/images/icons/icon-edit.svg"
                      alt="Edit"
                      (click)="onEditItem(i)"
                    />
                    <img
                      src="../../../assets/images/icons/icon-delete.svg"
                      alt="Delete"
                      (click)="onRemoveItem(i)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="submit-btn-wrapper flex-middle">
        <button class="cmn-next-btn" (click)="onAddTask()" [disabled]="loading">
          <span *ngIf="!loading">{{taskData?.id ? 'Save':'Add Task'}}</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </div>
</section>
